import { QUANTITY_OPTIONS, SHOW_ALL_ITEMS_QUANTITY } from '@/shared/config';
import type { OrderOptions } from '@/shared/lib';

export const COLLABORATOR_TABLE_HEADERS = [
  'Colaborador',
  'Matrícula',
  'Cargo',
  'Status',
  'Ações',
];

export const COLLABORATOR_SEARCH_FIELDS = [
  { id: 'collaborator', name: 'Colaborador' },
  { id: 'registrationNumber', name: 'Matrícula' },
];

export const COLLABORATOR_QUANTITY_OPTIONS = QUANTITY_OPTIONS.map((option) =>
  option.id === SHOW_ALL_ITEMS_QUANTITY ? { ...option, name: 'Todos os colaboradores' } : option
);

export const COLLABORATOR_ORDER_OPTIONS: OrderOptions[] = [
  { label: 'Por ordem alfabética crescente', sort: 'name', order: 'asc' },
  { label: 'Por ordem alfabética decrescente', sort: 'name', order: 'desc' },
  { label: 'Por maior número de Matrícula', sort: 'registrationNumber', order: 'desc' },
  { label: 'Por menor número de Matrícula', sort: 'registrationNumber', order: 'asc' },
];

export const COLLABORATOR_TABLE_COLUMN_WIDTH_CLASSES = [
  'w-[30%]',
  'w-[15%] whitespace-nowrap',
  'w-[20%] whitespace-nowrap',
  'w-[17%]',
  'w-[18%]',
];

export function collaboratorTableCellModifierClass(index: number) {
  return COLLABORATOR_TABLE_COLUMN_WIDTH_CLASSES[index].split(' ').slice(1).join(' ');
}
